import React, { useState } from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Alert from "@material-ui/lab/Alert";

const ConfirmDialog = (props) => {
  const { t } = useTranslation();
  const { confirmDialog, setConfirmDialog } = props;

  return (
    <Dialog open={confirmDialog.isOpen} disableBackdropClick>
      <DialogTitle id="form-dialog-title">{t(confirmDialog.title)}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t(confirmDialog.subTitle)}</DialogContentText>
      </DialogContent>
      {confirmDialog.alertMsg && (
        <DialogContent>
          <Alert severity="warning">{t(confirmDialog.alertMsg)}</Alert>
        </DialogContent>
      )}
      <DialogActions>
        <Button
          disabled={confirmDialog.isLoading}
          color="primary"
          variant="outlined"
          onClick={confirmDialog.onConfirm}
        >
          {t("pgReview.btnYes")}
        </Button>
        <Button
          disabled={confirmDialog.isLoading}
          variant="contained"
          color="primary"
          onClick={() =>
            setConfirmDialog({
              ...confirmDialog,
              isOpen: false,
            })
          }
        >
          {t("pgReview.btnNo")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Specifies the default values for props:
ConfirmDialog.defaultProps = {
  confirmDialog: {
    title: "pgPunch.tlConfirmation",
    subTitle: "pgReview.msgDeletePunch",
    alertMsg: "other.1",
  },
};

ConfirmDialog.propTypes = {
  confirmDialog: PropTypes.object.isRequired,
  setConfirmDialog: PropTypes.func.isRequired,
  onClickHandle: PropTypes.func.isRequired,
};

export default ConfirmDialog;
